import { render, staticRenderFns } from "./ListDetail.vue?vue&type=template&id=2614ba54"
import script from "./ListDetail.vue?vue&type=script&lang=js"
export * from "./ListDetail.vue?vue&type=script&lang=js"
import style0 from "./ListDetail.vue?vue&type=style&index=0&id=2614ba54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports